// ── Test / seed team members ──────────────────────────────────────────────
// These are purely client-side fixtures used until a real team API exists.
// Avatars are generated from DiceBear (no auth required).

const seed = (name) =>
  `https://api.dicebear.com/8.x/initials/svg?seed=${encodeURIComponent(name)}&backgroundColor=transparent&fontFamily=JetBrains%20Mono&fontSize=40&fontWeight=700`

export const TEST_USERS = [
  { id: 'u1', name: 'Austin O.',  initials: 'AO', color: '#4ade80', avatarUrl: seed('Austin O.') },
  { id: 'u2', name: 'Sara K.',    initials: 'SK', color: '#60a5fa', avatarUrl: seed('Sara K.') },
  { id: 'u3', name: 'Marco R.',   initials: 'MR', color: '#f59e0b', avatarUrl: seed('Marco R.') },
  { id: 'u4', name: 'Priya N.',   initials: 'PN', color: '#c084fc', avatarUrl: seed('Priya N.') },
  { id: 'u5', name: 'Devon C.',   initials: 'DC', color: '#f87171', avatarUrl: seed('Devon C.') },
]

/** Look up a user by their assignedTo name string */
export function getUserByName(name) {
  if (!name) return null
  return TEST_USERS.find(u => u.name === name) ?? null
}
